export default __webpack_public_path__ + "static/media/phoenix-logo-design-11-510x510.dad6ec20.png";